<!-- escapeOwnedExternally: this component's own document listener is the reference's one Escape
     arbiter (palette/tour/IME/dialog-rank arms) — the primitive's unguarded arm would close the
     panel on exactly the stood-down states. -->
<app-slide-panel
  [title]="'topbar.keyboardShortcuts' | translate"
  [closeOnClickOutside]="false"
  [escapeOwnedExternally]="true"
  [zIndex]="panelZIndex()"
  width="md"
  (closed)="onClosed()">
  <app-shortcut-list [groups]="groups()" />
</app-slide-panel>
